<app-chart [entries]="metrics$ | async" [options]="chartOptions" />
<div class="flex" *ngIf="metricType$ | async as activeMetricType">
  <button
    class="button-small"
    (click)="handleChangeMetricType(MetricType.OrderTotal)"
    [class.active]="activeMetricType === MetricType.OrderTotal"
  >
    {{ '订单总额' }}
  </button>
  <button
    class="ml-1 button-small"
    (click)="handleChangeMetricType(MetricType.OrderCount)"
    [class.active]="activeMetricType === MetricType.OrderCount"
  >
    {{ '订单数' }}
  </button>
  <button
    class="ml-1 button-small"
    (click)="handleChangeMetricType(MetricType.AverageOrderValue)"
    [class.active]="activeMetricType === MetricType.AverageOrderValue"
  >
    {{ '平均订单金额' }}
  </button>
  <div class="flex-spacer"></div>
  <button class="button-small" (click)="refresh()">
    <clr-icon shape="refresh"></clr-icon>
  </button>
</div>
